import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200" role="contentinfo">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="text-2xl font-heading text-accent-500 font-bold tracking-wide">
                妖精漫画
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              妖精漫画网致力于为广大漫画爱好者提供免费、优质的漫画阅读体验。海量韩漫日漫国漫资源，热门完结连载全部免费看，下拉式阅读超爽体验。
            </p>
          </div>

          <div>
            <h4 className="text-base font-heading text-background-100 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-accent-500 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-base font-heading text-background-100 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-accent-500 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-background-400 hover:text-accent-500 transition-colors cursor-pointer">
                  全部漫画
                </Link>
              </li>
              <li>
                <Link to="/category/hanman" className="text-sm text-background-400 hover:text-accent-500 transition-colors cursor-pointer">
                  韩漫专区
                </Link>
              </li>
              <li>
                <Link to="/category/riman" className="text-sm text-background-400 hover:text-accent-500 transition-colors cursor-pointer">
                  日漫专区
                </Link>
              </li>
              <li>
                <Link to="/category/guoman" className="text-sm text-background-400 hover:text-accent-500 transition-colors cursor-pointer">
                  国漫专区
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-accent-500 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-heading text-background-100 mb-4">联系与声明</h4>
            <ul className="space-y-2.5 text-sm text-background-400">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5"></i>
                <span>service@bjyongkun.cn</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5"></i>
                <span>本站资源均来自网络，仅供学习交流</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-copyright-line mt-0.5"></i>
                <span>如有侵权请联系删除</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {currentYear} 妖精漫画网 - 版权所有 | 免费漫画大全，全集免费在线阅读
          </p>
          <div className="flex items-center gap-1 text-sm text-background-500">
            <span>友情链接：</span>
            <a href="#" className="hover:text-accent-500 transition-colors cursor-pointer" rel="nofollow">漫画导航</a>
            <span className="mx-1">·</span>
            <a href="#" className="hover:text-accent-500 transition-colors cursor-pointer" rel="nofollow">动漫之家</a>
            <span className="mx-1">·</span>
            <a href="#" className="hover:text-accent-500 transition-colors cursor-pointer" rel="nofollow">漫客栈</a>
          </div>
        </div>
      </div>
    </footer>
  );
}